import React from 'react';
import { cn } from '../../lib/utils';

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  /** Show error state */
  error?: boolean;
  /** Error message to display */
  errorMessage?: string;
}

/**
 * Input component with error state handling
 *
 * @example
 * ```tsx
 * <Input type="email" placeholder="Enter email" />
 * <Input error errorMessage="Email is required" />
 * <Input disabled placeholder="Disabled input" />
 * ```
 */
export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ error = false, errorMessage, className, ...props }, ref) => {
    return (
      <div className="w-full">
        <input
          ref={ref}
          className={cn(
            'input',
            'w-full',
            error && 'input-error',
            className
          )}
          {...props}
        />
        {error && errorMessage && (
          <p className="mt-2 text-sm text-red-600 flex items-center gap-1">
            <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
            </svg>
            {errorMessage}
          </p>
        )}
      </div>
    );
  }
);

Input.displayName = 'Input';
